// employeeNotificationSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import {
  EmployeeNotificationState
} from './employeeNotificationTypes';
import {
  assignNotification,
  markNotificationAsRead,
  fetchEmployeeNotifications
} from './employeeNotificationActions';

const initialState: EmployeeNotificationState = {
  notifications: [],
  loading: false,
  error: undefined,
};

const employeeNotificationSlice = createSlice({
  name: 'employeeNotification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Assign Notification
      .addCase(assignNotification.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(assignNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications.push(action.payload);
      })
      .addCase(assignNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Mark as Read
      .addCase(markNotificationAsRead.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(markNotificationAsRead.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(markNotificationAsRead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Notifications
      .addCase(fetchEmployeeNotifications.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEmployeeNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchEmployeeNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export default employeeNotificationSlice.reducer;
